import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  ListSubheader,
} from "@mui/material";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { auth } from "../../firebase";
import ClientForm from "./ClientForm";
import { decryptField } from "../../utils/encryption"; // ✅ import

export default function ClientSelect({ value, onChange }) {
  const db = getFirestore();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showClientForm, setShowClientForm] = useState(false);

  const fetchClients = async () => {
    const user = auth.currentUser;
    if (!user) return;

    const snapshot = await getDocs(
      collection(db, "users", user.uid, "clients")
    );

    const result = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        name: decryptField(data.name || ""),
        company: decryptField(data.company || ""),
      };
    });

    result.sort((a, b) => a.name.localeCompare(b.name));
    setClients(result);
    setLoading(false);
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleClientAdded = async () => {
    setShowClientForm(false);
    await fetchClients();
    const updatedSnapshot = await getDocs(
      collection(db, "users", auth.currentUser.uid, "clients")
    );
    const latest = updatedSnapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds)[0];
    if (latest?.id) onChange(latest.id);
  };

  return (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel>Select Client</InputLabel>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            label="Select Client"
          >
            {clients.map((client) => (
              <MenuItem key={client.id} value={client.id}>
                {client.name || "Unnamed"}
                {client.company ? ` (${client.company})` : ""}
              </MenuItem>
            ))}
            <ListSubheader>────────────</ListSubheader>
            <MenuItem
              value=""
              onClick={() => setShowClientForm(true)}
              sx={{ fontStyle: "italic", color: "primary.main" }}
            >
              ➕ Add New Client
            </MenuItem>
          </Select>
        )}
      </FormControl>

      <ClientForm
        open={showClientForm}
        onClose={() => setShowClientForm(false)}
        onSuccess={handleClientAdded}
      />
    </>
  );
}
